import { Tabs, Tab } from "@mui/material";
import { useRouter } from "next/router";
import * as T from "common/src/bindings/Translation2";

export default function DropTablesNav({ route }: { route: string }) {
  const router = useRouter();
  return (
    <div className="px-3 pt-2 pb-0 mb-3 sticky top-[48px] md:top-[92px] bg-bg0 z-20">
      <Tabs
        value={route}
        variant="scrollable"
        onChange={(_, t) => {
          switch (t) {
            case "Cypher":
              router.push("/info/set-14/tables/cypher");
              break;
            case "TreasureDragon":
              router.push("/info/set-14/tables/treasure-dragon");
              break;
            case "Hacked Egg":
              router.push("/info/set-14/tables/hacked-egg");
              break;
            case "ExaltedAdventure":
              router.push("/info/set-14/tables/exalted-adventure");
              break;
            case "Blessing":
              router.push("/info/set-14/tables/blessing");
              break;
            case "Augments":
              router.push("/info/set-14/tables/augments");
              break;
            case "LootOrbs":
              router.push("/info/set-14/tables/loot-orbs");
              break;
            case "Reroll":
              router.push("/info/set-14/tables/reroll");
              break;
            case "Double Up":
              router.push("/info/set-14/tables/double-up");
              break;
            case "Golden Egg":
              router.push("/info/set-14/tables/golden-egg");
              break;
            case "Thief's Gloves":
              router.push("/info/set-14/tables/thiefs-gloves");
              break;
            case "Loot Subscription":
              router.push("/info/set-14/tables/loot-subscription");
              break;
            case "Call to Chaos":
              router.push("/info/set-14/tables/call-to-chaos");
              break;
            case "Magic Roll":
              router.push("/info/set-14/tables/magic-roll");
              break;
            case "Expected Unexpectedness":
              router.push("/info/set-14/tables/expected-unexpectedness");
              break;
          }
        }}
      >
        <Tab label={T.traits("TFT14_Suits")} value="Cypher" />
        <Tab label={T.common("Treasure Dragon")} value="TreasureDragon" />
        <Tab label={T.common("Hacked Egg")} value="Hacked Egg" />
        <Tab label={T.augments("MagicRoll")} value="Magic Roll" />
        <Tab
          label={T.augments("ExpectedUnexpectedness")}
          value="Expected Unexpectedness"
        />
        <Tab
          label={T.augments("AnExaltedAdventure")}
          value="ExaltedAdventure"
        />
        {/* <Tab label={T.common("Mel's Blessing")} value="Blessing" /> */}
        <Tab label={T.common("Augments")} value="Augments" />
        <Tab label={T.common("Loot Orbs")} value="LootOrbs" />
        <Tab label={T.common("Reroll")} value="Reroll" />
        <Tab label={T.augments("11Calltochaos")} value="Call to Chaos" />
        {/* <Tab label={T.common("Double Up")} value="Double Up" /> */}
        <Tab label={T.common("Golden Egg")} value="Golden Egg" />
        <Tab
          label={T.common("TFT_Portals_Unique_LootSubscription")}
          value="Loot Subscription"
        />
        <Tab label={T.items("ThiefsGloves")} value="Thief's Gloves" />
      </Tabs>
    </div>
  );
}
